// extracted by mini-css-extract-plugin
module.exports = {"Container":"StepDisplay_Container__23Ui_","Step":"StepDisplay_Step__3bwxR","Current":"StepDisplay_Current__24nD3"};